/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_AfterInputs */



/**
* | output |
* | --- |
* | "After" |
*
* @param {Merge_Swal_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_after = /** @type {((inputs?: Merge_Swal_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dopo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("После")
	if (locale === "es") return /** @type {LocalizedString} */ ("Después")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("后")
	if (locale === "ja") return /** @type {LocalizedString} */ ("後")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Depois")
	return /** @type {LocalizedString} */ ("After")
});